import { Card, H4, P1, P2, Icon, useWindowSize } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useTransition, animated } from 'react-spring'

import styles from './TextBlock.module.scss'

const TextBlock = ({ title, text, badge }) => {
  const { screenWidth } = useWindowSize()

  const [showMore, setShowMore] = useState(true)

  useEffect(() => {
    if (screenWidth > 601 && !showMore) {
      setShowMore(true)
    } else if (screenWidth !== 0 && showMore) {
      setShowMore(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth])

  const transition = useTransition(showMore, {
    from: { transform: 'translateY(-20px)', opacity: 0 },
    enter: { transform: 'translateY(0)', opacity: 1 },
    leave: { transform: 'translateY(-20px)', opacity: 0 },
    config: { duration: 200 }
  })

  return (
    <Card className={styles.TextBlock}>
      <div className={`${styles.Header} ${showMore ? styles.isOpen : ''}`}>
        {title && (
          <H4 weight="semibold " className={styles.Title}>
            {title}
          </H4>
        )}
        <button type="button" className={styles.Heading} onClick={() => setShowMore(prev => !prev)}>
          {showMore ? <Icon icon="icon-point-up" size={18} /> : <Icon icon="icon-point-down" size={18} />}
        </button>
      </div>

      {transition(
        (springStyles, item) =>
          item && (
            <animated.div style={springStyles} className={styles.Content}>
              <div className={styles.BadgeContainer}>
                {badge.map(({ text: badgeText, icon, id }) => (
                  <div key={id} className={`${styles.Badge} ${styles.Border}`}>
                    <img src={icon} alt={badgeText} />
                    <P2>{badgeText}</P2>
                  </div>
                ))}
              </div>

              {text && <P1 className="rte" nestedStyles dangerouslySetInnerHTML={{ __html: text }} />}
            </animated.div>
          )
      )}
    </Card>
  )
}

TextBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  badge: PropTypes.arrayOf(PropTypes.object)
}

TextBlock.defaultProps = {
  title: '',
  text: '',
  badge: []
}

export default TextBlock
